// extracted by mini-css-extract-plugin
export default {"container":"video_dialog__container__Tj_dG","dialogWrapper":"video_dialog__dialogWrapper__ER9jw"};